import React, { type FC, type PropsWithChildren } from 'react';
import CheckValidationContextProvider from './CheckValidationContext/CheckValidationContextProvider';
import IsInRiskCountryContextProvider from './IsInRiskCountryContext/IsInRiskCountryContextProvider';
import RouteContextProvider from './RouteContext';
import ShowCrispContextProvider from './ShowCrispContextProvider';
import ShowMiniatureContextProvider from './ShowMiniatureContext/ShowMiniatureContextProvider';

const ContextProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <IsInRiskCountryContextProvider>
      <CheckValidationContextProvider>
        <ShowCrispContextProvider>
          <ShowMiniatureContextProvider>
            <RouteContextProvider>{children}</RouteContextProvider>
          </ShowMiniatureContextProvider>
        </ShowCrispContextProvider>
      </CheckValidationContextProvider>
    </IsInRiskCountryContextProvider>
  );
};

export default ContextProvider;
